export default "__VITE_ASSET__d2238e12__"